module.exports = __webpack_public_path__ + "img/arrow.b7abfc20.png";